import * as React from "react";
import { DateSelect } from "../../atoms/forms/DateSelect";
import { ICommonControlWithMinMax } from "./ICommonInputsControls";

// All the incoming values
interface IProps {
    label?: string;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonControlWithMinMax<Date>;
export const DateInput = (props: AllProps) => {
    return (
        <DateSelect
            label={props.label || ""}
            value={props.value}
            loading={props.loading}
            disabled={props.disabled}
            required={props.required}
            error={props.error}
            placeholder={props.placeholder}
            prevalidate={props.prevalidate}
            icon={props.icon}
            minValue={props.minValue}
            maxValue={props.maxValue}
            onChange={props.onChange}
            onValidate={props.onValidate}
        />
    );
}

